import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
// import { HeaderComponent } from './header/header.component';
// import { FooterComponent } from './footer/footer.component';
// import { SideNavComponent } from './side-nav/side-nav.component';
import { RouterModule } from '@angular/router';
import { SlotComponent } from './slot/slot.component';
import { SlotDetailComponent } from './slot-detail/slot-detail.component';
import { FilterPipe } from './pipes/filter.pipe';
import { PasswordStrengthBarComponent } from './password-strength-bar/password-strength-bar.component';
import { FilterMeetingHostPipe } from '../pipes/meetingHost.pipe';
import { AddLimiterPipe } from 'src/app/shared/pipes/add-limiter.pipe';
import { DropdownTextLimiterPipe } from 'src/app/shared/pipes/dropdown-text-limiter.pipe';
import { EmptyStateComponent } from 'src/app/shared/error-pages/empty-state/empty-state.component'
import { EmailRestricterDirective } from './Directives/email-restricter.directive';
import { CustomDatePipe } from './pipes/custom-date.pipe'


@NgModule({

  // declarations: [HeaderComponent, FooterComponent,
  //   SideNavComponent, SlotComponent, SlotDetailComponent, SlotDetailComponent, FilterPipe, PasswordStrengthBarComponent, FilterMeetingHostPipe, AddLimiterPipe,DropdownTextLimiterPipe,EmptyStateComponent,EmailRestricterDirective, CustomDatePipe],

  declarations: [SlotComponent, SlotDetailComponent, SlotDetailComponent,PasswordStrengthBarComponent],
  imports: [
    CommonModule,
    RouterModule
  ],
// <<<<<<< Updated upstream
//   exports: [
//     HeaderComponent, FooterComponent,
//     SideNavComponent, SlotComponent, SlotDetailComponent, PasswordStrengthBarComponent, FilterPipe, FilterMeetingHostPipe, AddLimiterPipe,DropdownTextLimiterPipe,EmptyStateComponent,EmailRestricterDirective,CustomDatePipe
// =======
  exports: [SlotComponent, SlotDetailComponent, PasswordStrengthBarComponent
  ],
})
export class SharedModule { }
